import { render, staticRenderFns } from "./InnerShadowLIcon.vue?vue&type=template&id=9297b518&"
import script from "./InnerShadowLIcon.vue?vue&type=script&lang=js&"
export * from "./InnerShadowLIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports